import Layout from "../components/layout/Layout";
import GeneralSettings from "../components/page/GeneralSettings";

const GeneralSettingsPage = () => {

  return (
    <Layout>
        <GeneralSettings />
    </Layout>
  );
};
export default GeneralSettingsPage;
